var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Sider',{staticClass:"layout-left-sider",attrs:{"width":230}},[_c('AsideMenu')],1),_vm._v(" "),_c('Layout',{staticClass:"layout-inner"},[_c('Header',[_c('TopHeader')],1),_vm._v(" "),_c('Content',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }